// eslint-disable-next-line import/prefer-default-export
export const MANUSCRIPT_V1_API_URL_PREFIX = '/suite/api/manuscript/v1';
